import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Select from 'react-select';
import WithholdingList from "containers/property/WithholdingList";
import { PacmanLoader } from 'react-spinners';



export default class WithholdingProofingList extends Component {
    constructor(props) {
        super(props);
        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);                  
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
        this.bulkSaveRecords = this.bulkSaveRecords.bind(this);
        this.state = {
            searching: false,
            isLoading: true,
            withholdings: [],
            cityscopeOptions: [],
            selectedCityscope: null,
            selectedLocation: null,
            selectedWithholdingReason: null,
            filter: {},
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false,
            propertykey: null,
            user: null,
            location: null,
            classification: null,
            withholdingreason: null,
            cityscope: null,
            dataSetPrimaryKey: "property_withholding_id"
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    

    async componentDidMount() {
        console.log("In WithholdingList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        const cityscopeOptions = await this.getCityscopes();
        if (cityscopeOptions) {     
            this.setState(state => ({ cityscopeOptions }));
        }

        
        try {
            const withholdings = await this.getWithholdings({
                                                    propertykey: this.state.propertykey,
                                                    user: this.state.user,
                                                    location: this.state.location,
                                                    classification: this.state.classification,
                                                    withholdingreason: this.state.withholdingreason,
                                                    cityscope: this.state.cityscope
                                                    });
            this.setState({ withholdings });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
        document.title = "HOLD Proofing" ;
    }

    
    componentWillUnmount() {

        this.setState({ withholdings: [] });        
    }


    
    async getWithholdings(filter) {
        console.log("Inside getWithholdings() ");
        
        return API.get("colin", "/withholdings", {'queryStringParameters': filter});
      
    }

    async getCityscopes() {
        return API.get("colin", `/cityscopes/dropdown`);                
    }


    validateRelatedRecord(record, set) {
        
 

        
        return [true,];
    }
    updateTableState(data, set) {
        
        this.setState({
            [set]: data
        });
    }
    
    async bulkSaveRecords(records){
        for(var i = records.length-1; i >= 0; i--) {
            var record = records[i]
            // console.log(record)
            API.put("colin", `/properties/${record["property_key"]}/withholdings/${record["property_withholding_id"]}`, {
                body: record
            })
        }
    }

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/properties/${record["property_key"]}/withholdings/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/properties/${record["property_key"]}/withholdings/${record["property_withholding_id"]}`, {
            body: record
        });
             
    }

    

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

   
    
    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        
        const withholdings = await this.getWithholdings( {
                            propertykey: this.state.propertykey,
                            user: this.state.user,
                            location: this.state.location,
                            classification: this.state.classification,
                            withholdingreason: this.state.withholdingreason,
                            cityscope: this.state.cityscope
                        });

        this.setState({ withholdings });

        this.setState({ isLoading: false });
                
     }




    validateRecord(record) {

       
        //Check street name not blank
        // if (record.suburb === "") {
        //     return [false,"Suburb cannot be blank. The record has not been saved"];
        // }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let withholdings = [...this.state.withholdings];
        withholdings[cellInfo.index][cellInfo.column.id] = event.target.value;
        withholdings[cellInfo.index].modified = true;
        this.setState({withholdings});
    };
    handleNumberChange = (cellInfo, event) => {
        let withholdings = [...this.state.withholdings];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        withholdings[cellInfo.index][cellInfo.column.id] = Number(val);
        withholdings[cellInfo.index].modified = true;
        this.setState({withholdings});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let withholdings = [...this.state.withholdings];
        withholdings[cellInfo.index][cellInfo.column.id] = event.target.checked;
        withholdings[cellInfo.index].modified = true;
        this.setState({withholdings});
    };

    handleDateChange = (cellInfo, event) => {
        let withholdings = [...this.state.withholdings];
        withholdings[cellInfo.index][cellInfo.column.id] = new Date(event);
        withholdings[cellInfo.index].modified = true;
        this.setState({withholdings});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false, showWarning: false });
        let withholdings = [...this.state.withholdings];
        for (var i=0; i<withholdings.length; i++){
            
                    const validation = this.validateRecord(withholdings[i]);
                    if (validation[0] === true) {
                        console.log("Is valid");
                        
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (withholdings[i].hasOwnProperty("new_record")) {
                                if (withholdings[i].new_record === true) {
                                    
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(withholdings[i]);
                            if (result.result) {
                                withholdings[i].modified = false;
                                if (withholdings[i].hasOwnProperty("new_record")) {
                                    if (withholdings[i].new_record === true) {

                                        withholdings[i][this.state.dataSetPrimaryKey] = result.id;
                                       
                                        this.setState({ savingNewRecord: false });
                                    }
                                    withholdings[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (withholdings[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                this.setState({ savingNewRecord: false });
                return;
            }
     
        }   
        if (withholdings[0].hasOwnProperty("sort_order")) {
            withholdings.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({withholdings});

    }


    handleCityscopeChange = async (selectedCityscope) => {
        if (selectedCityscope){
            this.setState({ selectedCityscope
                ,cityscope: selectedCityscope.map(r=>r.value).join(",")
                , modified: true },this.handleBlur)
        }else{
            this.setState(state => ({ selectedCityscope }));
            this.setState(state => ({ cityscope: null }));
        }
        
        
    }

    handleLocationChange = async (selectedLocation) => {
        if (selectedLocation){
        this.setState(state => ({ selectedLocation }));
        this.setState(state => ({ location: selectedLocation.value }));
        }else{
            this.setState(state => ({ selectedLocation }));
            this.setState(state => ({ location: null }));
        }        
    }

    handleWithholdingReasonChange = async (selectedWithholdingReason) => {
        if (selectedWithholdingReason){
        this.setState(state => ({ selectedWithholdingReason }));
        this.setState(state => ({ withholdingreason: selectedWithholdingReason.value }));
        }else{
            this.setState(state => ({ selectedWithholdingReason }));
            this.setState(state => ({ withholdingreason: null }));
        }        
    }

    handlePrimaryClassificationChange = async (selectedClassification) => {
        if (selectedClassification){
        this.setState(state => ({ selectedClassification }));
        this.setState(state => ({ classification: selectedClassification.value }));
        }else{
            this.setState(state => ({ selectedClassification }));
            this.setState(state => ({ classification: null }));
        }        
    }

    
    
    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }
    renderTable(){
        return(<WithholdingList
            filter={this.props.filter}
            isAuthenticated={this.props.isAuthenticated}
            isLoading={this.state.isLoading}
            controlType="table"
            saveForm={this.saveForm}
            user={this.props.user}
            data={this.state.withholdings}
            updateTableState={this.updateTableState}
            saveRecord={this.saveRecord}
            bulkSaveRecords={this.bulkSaveRecords}
            deleteRecord={this.props.deleteRecord}
            validateRelatedRecord={this.validateRecord}
            withholdingReasons={this.withholdingReasons}
            userPermissions={this.props.userPermissions}
            />)
    }

    renderComponent() {
        return (
            <div className="withholdings">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                    <Col lg={2}>
                            <Form.Group controlId="propertykey">
                                <Form.Control
                                    value={this.state.propertykey}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="Cityscope Reference starting"
                                    
                                />
                            </Form.Group>
                            </Col>
                        
                      
                        <Col lg={1}>
                            <Form.Group controlId="user">
                                <Form.Control
                                    value={this.state.user}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="User Name"
                                    
                                />
                            </Form.Group>
                            </Col>
                        
                        <Col lg={1}>
                        <Form.Group controlId="location">                                                                                        
                            <Select
                                    value={this.state.selectedLocation}
                                    onChange={this.handleLocationChange}
                                    options={[{value: "onshore", label: "Onshore"}, {value: "offshore", label: "Offshore"}]}
                                    placeholder="Location"
                                    isClearable
                                />
                                </Form.Group>
                        </Col>             
                        <Col  lg={1}>
                                <Form.Group controlId="cityscope" >                        
                                <Select
                                    value={this.state.selectedCityscope}
                                    onChange={this.handleCityscopeChange}
                                    options={this.state.cityscopeOptions}
                                    placeholder="Cityscope"
                                    isClearable
                                    isMulti
                                />
                                </Form.Group>
                            </Col>      
                            <Col  lg={1}>
                                <Form.Group controlId="withholdingreason" >                        
                                <Select
                                    value={this.state.selectedWithholdingReason}
                                    onChange={this.handleWithholdingReasonChange}
                                    options={this.props.withholdingReasons}
                                    placeholder="HOLD Reason"
                                    isClearable                                    
                                />
                                </Form.Group>
                            </Col>  
                            <Col  lg={1}>
                                <Form.Group controlId="classification" >                        
                                <Select
                                    value={this.state.selectedClassification}
                                    onChange={this.handlePrimaryClassificationChange}
                                    options={this.props.classificationOptions}
                                    placeholder="Primary Classification"
                                    isClearable                                    
                                />
                                </Form.Group>
                            </Col>     
                        <Col lg={1}>
                        <Button type="submit" className="float-left">Search</Button>{" "}
                        
                        </Col>
                        <Col lg={1}>
                        
                        <Button type="submit" className="float-left">Refresh List</Button>
                        </Col>
                        
                       

                    </Form.Row>
                </Form>
               
                        <div className="WithholdingList">
                            {!this.state.isLoading ? this.renderTable() : this.renderPacman()}
                            
                        </div>

            </div>
        );
    }


  render() {
    return (

        <div className="WithholdingList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
